import React from "react";
import { Sparkles } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { Eyebrow, SectionTitle, ReserveButton, MarketButton } from "@/components/shared";
import { Ornament } from "@/components/Ornament";
import { freshTreasures } from "@/data/treasures";

// "Heute frisch in der Wunderkammer" — live shop-window with dual CTA + FOMO.
export const FreshToday = ({ onOpen }) => {
  const { t, lang, contact } = useLang();
  return (
    <section data-testid="fresh-today" className="py-24 md:py-32 bg-cream grain-overlay">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-14" data-reveal>
          <Eyebrow>{t.fresh.eyebrow}</Eyebrow>
          <SectionTitle>{t.fresh.title}</SectionTitle>
          <p className="mt-5 text-espresso/65 text-lg font-sans leading-relaxed">{t.fresh.body}</p>
          <Ornament className="mt-6 justify-start opacity-70" width={200} />
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {freshTreasures.map((item, i) => (
            <article key={item.id} data-reveal data-reveal-delay={0.08 * i} data-testid={`fresh-${item.id}`}
              className="group relative rounded-2xl overflow-hidden bg-espresso flex flex-col">
              <button onClick={() => onOpen?.(item)} data-testid={`fresh-open-${item.id}`} className="relative block aspect-[4/5] overflow-hidden cursor-link">
                <img src={item.image} alt={item.name[lang]} className="w-full h-full object-cover transition-transform duration-[1200ms] group-hover:scale-110" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-espresso-deep/90 via-transparent to-transparent" />
                <span className="absolute top-3 left-3 inline-flex items-center gap-1.5 text-[10px] tracking-widest uppercase bg-gold text-espresso-deep px-3 py-1 rounded-full font-medium shadow-[0_0_16px_rgba(200,169,126,0.5)]">
                  <Sparkles className="w-3 h-3" /> {t.fresh.eyebrow}
                </span>
              </button>
              <div className="p-5 flex flex-col flex-1">
                <span className="text-[10px] tracking-[0.25em] uppercase text-gold/80">{item.tag[lang]} · {item.era}</span>
                <h3 className="font-serif text-xl text-cream mt-1">{item.name[lang]}</h3>
                <p className="mt-2 text-[11px] text-rose/90 font-sans leading-snug">{t.fresh.fomo}</p>
                <div className="mt-auto pt-4 flex items-center justify-between gap-2">
                  <span className="text-gold font-serif text-lg">{item.price}</span>
                </div>
                <div className="mt-3 grid grid-cols-1 gap-2">
                  <ReserveButton phone={contact.whatsapp} name={item.name.de} label={t.cta.reserve} testid={`fresh-reserve-${item.id}`} className="w-full" />
                  <MarketButton url={item.market.url} label={item.market.platform === "ricardo" ? t.cta.ricardo : t.cta.tutti} testid={`fresh-market-${item.id}`} className="w-full" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FreshToday;
